import isServerSideRendering from '~/utilities/isServerSideRendering';
import { logError } from '~/utilities/loggers';
import safeParse from '~/utilities/safeParse';

export function loadItemFromSessionStorage<T>(name: string): T | undefined {
  if (isServerSideRendering) return undefined;

  try {
    const serializedState = window.sessionStorage.getItem(name);

    return serializedState ? safeParse<T>(serializedState) : undefined;
  } catch (err) {
    logError(err, { location: 'Load item from sessionStorage', key: name });

    return undefined;
  }
}

export function saveItemToSessionStorage(name: string, state: any): boolean {
  if (isServerSideRendering) return false;

  try {
    window.sessionStorage.setItem(name, JSON.stringify(state));

    return true;
  } catch (err) {
    logError(err, { location: 'Save item to sessionStorage', key: name });

    return false;
  }
}

export function removeItemFromSessionStorage(name: string): boolean {
  if (isServerSideRendering) return false;

  try {
    window.sessionStorage.removeItem(name);

    return true;
  } catch (err) {
    logError(err, { location: 'Remove item from sessionStorage', key: name });

    return false;
  }
}
